import '../../assets/base.scss';

import apiProviders from '../../api/providers';
import Router from '../Router';
import { Provider as ThemeProvider } from '../../api/theme';
import { Provider as DesignTokensProvider } from '../../api/designTokens';
import '../../utils/loadFontAwesomeIcons';
import { Routes } from '../../types';
import DataSyncStatusBar from '../DataSyncStatusBar/DataSyncStatusBar';

import { ImportedRecordRetirementProvider } from '../../permissions';

import Providers from './providers';
import defaultTheme from './defaultTheme';
import RTToast from '../RTToast';
import CardRemittanceResume from '../CardRemittanceResume';

interface Props {
    routes: Routes;
}
const App = ({ routes }: Props) => {
    return (
        <Providers providers={apiProviders}>
            {/* Tokens resolve inside the api providers (they read user
                preferences) and outside the theme, which consumes them. */}
            <DesignTokensProvider>
                <ThemeProvider defaultTheme={defaultTheme}>
                    <RTToast />
                    {/* Fetched once for the whole app: useImportedLock() is called
                        on most screens, so a per-component fetch would be one
                        request per mount. */}
                    <ImportedRecordRetirementProvider>
                        <Router routes={routes} />
                    </ImportedRecordRetirementProvider>
                    <DataSyncStatusBar />
                    {/* Issues a Remittance after a Masleka card charge, once the
                        gateway has redirected the window back to the former page. */}
                    <CardRemittanceResume />
                </ThemeProvider>
            </DesignTokensProvider>
        </Providers>
    );
};

export default App;
